import _inherits from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _classCallCheck from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Vector4 } from '../math/Vector4.js';
import { Vector3 } from '../math/Vector3.js';
import { Vector2 } from '../math/Vector2.js';
import { Color } from '../math/Color.js';
import { StaticDrawUsage } from '../constants.js';

var _vector = /*@__PURE__*/new Vector3();

var _vector2 = /*@__PURE__*/new Vector2();

var BufferAttribute = /*#__PURE__*/function () {
  function BufferAttribute(array, itemSize, normalized) {
    _classCallCheck(this, BufferAttribute);

    if (Array.isArray(array)) {
      throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
    }

    this.name = '';
    this.array = array;
    this.itemSize = itemSize;
    this.count = array !== undefined ? array.length / itemSize : 0;
    this.normalized = normalized === true;
    this.usage = StaticDrawUsage;
    this.updateRange = {
      offset: 0,
      count: -1
    };
    this.version = 0;
  }

  _createClass(BufferAttribute, [{
    key: "onUploadCallback",
    value: function onUploadCallback() {}
  }, {
    key: "needsUpdate",
    set: function set(value) {
      if (value === true) this.version++;
    }
  }, {
    key: "setUsage",
    value: function setUsage(value) {
      this.usage = value;
      return this;
    }
  }, {
    key: "copy",
    value: function copy(source) {
      this.name = source.name;
      this.array = new source.array.constructor(source.array);
      this.itemSize = source.itemSize;
      this.count = source.count;
      this.normalized = source.normalized;
      this.usage = source.usage;
      return this;
    }
  }, {
    key: "copyAt",
    value: function copyAt(index1, attribute, index2) {
      index1 *= this.itemSize;
      index2 *= attribute.itemSize;

      for (var i = 0, l = this.itemSize; i < l; i++) {
        this.array[index1 + i] = attribute.array[index2 + i];
      }

      return this;
    }
  }, {
    key: "copyArray",
    value: function copyArray(array) {
      this.array.set(array);
      return this;
    }
  }, {
    key: "copyColorsArray",
    value: function copyColorsArray(colors) {
      var array = this.array;
      var offset = 0;

      for (var i = 0, l = colors.length; i < l; i++) {
        var color = colors[i];

        if (color === undefined) {
          console.warn('THREE.BufferAttribute.copyColorsArray(): color is undefined', i);
          color = new Color();
        }

        array[offset++] = color.r;
        array[offset++] = color.g;
        array[offset++] = color.b;
      }

      return this;
    }
  }, {
    key: "copyVector2sArray",
    value: function copyVector2sArray(vectors) {
      var array = this.array;
      var offset = 0;

      for (var i = 0, l = vectors.length; i < l; i++) {
        var vector = vectors[i];

        if (vector === undefined) {
          console.warn('THREE.BufferAttribute.copyVector2sArray(): vector is undefined', i);
          vector = new Vector2();
        }

        array[offset++] = vector.x;
        array[offset++] = vector.y;
      }

      return this;
    }
  }, {
    key: "copyVector3sArray",
    value: function copyVector3sArray(vectors) {
      var array = this.array;
      var offset = 0;

      for (var i = 0, l = vectors.length; i < l; i++) {
        var vector = vectors[i];

        if (vector === undefined) {
          console.warn('THREE.BufferAttribute.copyVector3sArray(): vector is undefined', i);
          vector = new Vector3();
        }

        array[offset++] = vector.x;
        array[offset++] = vector.y;
        array[offset++] = vector.z;
      }

      return this;
    }
  }, {
    key: "copyVector4sArray",
    value: function copyVector4sArray(vectors) {
      var array = this.array;
      var offset = 0;

      for (var i = 0, l = vectors.length; i < l; i++) {
        var vector = vectors[i];

        if (vector === undefined) {
          console.warn('THREE.BufferAttribute.copyVector4sArray(): vector is undefined', i);
          vector = new Vector4();
        }

        array[offset++] = vector.x;
        array[offset++] = vector.y;
        array[offset++] = vector.z;
        array[offset++] = vector.w;
      }

      return this;
    }
  }, {
    key: "applyMatrix3",
    value: function applyMatrix3(m) {
      if (this.itemSize === 2) {
        for (var i = 0, l = this.count; i < l; i++) {
          _vector2.fromBufferAttribute(this, i);

          _vector2.applyMatrix3(m);

          this.setXY(i, _vector2.x, _vector2.y);
        }
      } else if (this.itemSize === 3) {
        for (var _i = 0, _l = this.count; _i < _l; _i++) {
          _vector.fromBufferAttribute(this, _i);

          _vector.applyMatrix3(m);

          this.setXYZ(_i, _vector.x, _vector.y, _vector.z);
        }
      }

      return this;
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(m) {
      for (var i = 0, l = this.count; i < l; i++) {
        _vector.x = this.getX(i);
        _vector.y = this.getY(i);
        _vector.z = this.getZ(i);

        _vector.applyMatrix4(m);

        this.setXYZ(i, _vector.x, _vector.y, _vector.z);
      }

      return this;
    }
  }, {
    key: "applyNormalMatrix",
    value: function applyNormalMatrix(m) {
      for (var i = 0, l = this.count; i < l; i++) {
        _vector.x = this.getX(i);
        _vector.y = this.getY(i);
        _vector.z = this.getZ(i);

        _vector.applyNormalMatrix(m);

        this.setXYZ(i, _vector.x, _vector.y, _vector.z);
      }

      return this;
    }
  }, {
    key: "transformDirection",
    value: function transformDirection(m) {
      for (var i = 0, l = this.count; i < l; i++) {
        _vector.x = this.getX(i);
        _vector.y = this.getY(i);
        _vector.z = this.getZ(i);

        _vector.transformDirection(m);

        this.setXYZ(i, _vector.x, _vector.y, _vector.z);
      }

      return this;
    }
  }, {
    key: "set",
    value: function set(value) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.array.set(value, offset);
      return this;
    }
  }, {
    key: "getX",
    value: function getX(index) {
      return this.array[index * this.itemSize];
    }
  }, {
    key: "setX",
    value: function setX(index, x) {
      this.array[index * this.itemSize] = x;
      return this;
    }
  }, {
    key: "getY",
    value: function getY(index) {
      return this.array[index * this.itemSize + 1];
    }
  }, {
    key: "setY",
    value: function setY(index, y) {
      this.array[index * this.itemSize + 1] = y;
      return this;
    }
  }, {
    key: "getZ",
    value: function getZ(index) {
      return this.array[index * this.itemSize + 2];
    }
  }, {
    key: "setZ",
    value: function setZ(index, z) {
      this.array[index * this.itemSize + 2] = z;
      return this;
    }
  }, {
    key: "getW",
    value: function getW(index) {
      return this.array[index * this.itemSize + 3];
    }
  }, {
    key: "setW",
    value: function setW(index, w) {
      this.array[index * this.itemSize + 3] = w;
      return this;
    }
  }, {
    key: "setXY",
    value: function setXY(index, x, y) {
      index *= this.itemSize;
      this.array[index + 0] = x;
      this.array[index + 1] = y;
      return this;
    }
  }, {
    key: "setXYZ",
    value: function setXYZ(index, x, y, z) {
      index *= this.itemSize;
      this.array[index + 0] = x;
      this.array[index + 1] = y;
      this.array[index + 2] = z;
      return this;
    }
  }, {
    key: "setXYZW",
    value: function setXYZW(index, x, y, z, w) {
      index *= this.itemSize;
      this.array[index + 0] = x;
      this.array[index + 1] = y;
      this.array[index + 2] = z;
      this.array[index + 3] = w;
      return this;
    }
  }, {
    key: "onUpload",
    value: function onUpload(callback) {
      this.onUploadCallback = callback;
      return this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.array, this.itemSize).copy(this);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var data = {
        itemSize: this.itemSize,
        type: this.array.constructor.name,
        array: Array.prototype.slice.call(this.array),
        normalized: this.normalized
      };
      if (this.name !== '') data.name = this.name;
      if (this.usage !== StaticDrawUsage) data.usage = this.usage;
      if (this.updateRange.offset !== 0 || this.updateRange.count !== -1) data.updateRange = this.updateRange;
      return data;
    }
  }]);

  return BufferAttribute;
}();

BufferAttribute.prototype.isBufferAttribute = true; //

var Int8BufferAttribute = /*#__PURE__*/function (_BufferAttribute) {
  _inherits(Int8BufferAttribute, _BufferAttribute);

  var _super = _createSuper(Int8BufferAttribute);

  function Int8BufferAttribute(array, itemSize, normalized) {
    _classCallCheck(this, Int8BufferAttribute);

    return _super.call(this, new Int8Array(array), itemSize, normalized);
  }

  return _createClass(Int8BufferAttribute);
}(BufferAttribute);

var Uint8BufferAttribute = /*#__PURE__*/function (_BufferAttribute2) {
  _inherits(Uint8BufferAttribute, _BufferAttribute2);

  var _super2 = _createSuper(Uint8BufferAttribute);

  function Uint8BufferAttribute(array, itemSize, normalized) {
    _classCallCheck(this, Uint8BufferAttribute);

    return _super2.call(this, new Uint8Array(array), itemSize, normalized);
  }

  return _createClass(Uint8BufferAttribute);
}(BufferAttribute);

var Uint8ClampedBufferAttribute = /*#__PURE__*/function (_BufferAttribute3) {
  _inherits(Uint8ClampedBufferAttribute, _BufferAttribute3);

  var _super3 = _createSuper(Uint8ClampedBufferAttribute);

  function Uint8ClampedBufferAttribute(array, itemSize, normalized) {
    _classCallCheck(this, Uint8ClampedBufferAttribute);

    return _super3.call(this, new Uint8ClampedArray(array), itemSize, normalized);
  }

  return _createClass(Uint8ClampedBufferAttribute);
}(BufferAttribute);

var Int16BufferAttribute = /*#__PURE__*/function (_BufferAttribute4) {
  _inherits(Int16BufferAttribute, _BufferAttribute4);

  var _super4 = _createSuper(Int16BufferAttribute);

  function Int16BufferAttribute(array, itemSize, normalized) {
    _classCallCheck(this, Int16BufferAttribute);

    return _super4.call(this, new Int16Array(array), itemSize, normalized);
  }

  return _createClass(Int16BufferAttribute);
}(BufferAttribute);

var Uint16BufferAttribute = /*#__PURE__*/function (_BufferAttribute5) {
  _inherits(Uint16BufferAttribute, _BufferAttribute5);

  var _super5 = _createSuper(Uint16BufferAttribute);

  function Uint16BufferAttribute(array, itemSize, normalized) {
    _classCallCheck(this, Uint16BufferAttribute);

    return _super5.call(this, new Uint16Array(array), itemSize, normalized);
  }

  return _createClass(Uint16BufferAttribute);
}(BufferAttribute);

var Int32BufferAttribute = /*#__PURE__*/function (_BufferAttribute6) {
  _inherits(Int32BufferAttribute, _BufferAttribute6);

  var _super6 = _createSuper(Int32BufferAttribute);

  function Int32BufferAttribute(array, itemSize, normalized) {
    _classCallCheck(this, Int32BufferAttribute);

    return _super6.call(this, new Int32Array(array), itemSize, normalized);
  }

  return _createClass(Int32BufferAttribute);
}(BufferAttribute);

var Uint32BufferAttribute = /*#__PURE__*/function (_BufferAttribute7) {
  _inherits(Uint32BufferAttribute, _BufferAttribute7);

  var _super7 = _createSuper(Uint32BufferAttribute);

  function Uint32BufferAttribute(array, itemSize, normalized) {
    _classCallCheck(this, Uint32BufferAttribute);

    return _super7.call(this, new Uint32Array(array), itemSize, normalized);
  }

  return _createClass(Uint32BufferAttribute);
}(BufferAttribute);

var Float16BufferAttribute = /*#__PURE__*/function (_BufferAttribute8) {
  _inherits(Float16BufferAttribute, _BufferAttribute8);

  var _super8 = _createSuper(Float16BufferAttribute);

  function Float16BufferAttribute(array, itemSize, normalized) {
    _classCallCheck(this, Float16BufferAttribute);

    return _super8.call(this, new Uint16Array(array), itemSize, normalized);
  }

  return _createClass(Float16BufferAttribute);
}(BufferAttribute);

Float16BufferAttribute.prototype.isFloat16BufferAttribute = true;

var Float32BufferAttribute = /*#__PURE__*/function (_BufferAttribute9) {
  _inherits(Float32BufferAttribute, _BufferAttribute9);

  var _super9 = _createSuper(Float32BufferAttribute);

  function Float32BufferAttribute(array, itemSize, normalized) {
    _classCallCheck(this, Float32BufferAttribute);

    return _super9.call(this, new Float32Array(array), itemSize, normalized);
  }

  return _createClass(Float32BufferAttribute);
}(BufferAttribute);

var Float64BufferAttribute = /*#__PURE__*/function (_BufferAttribute10) {
  _inherits(Float64BufferAttribute, _BufferAttribute10);

  var _super10 = _createSuper(Float64BufferAttribute);

  function Float64BufferAttribute(array, itemSize, normalized) {
    _classCallCheck(this, Float64BufferAttribute);

    return _super10.call(this, new Float64Array(array), itemSize, normalized);
  }

  return _createClass(Float64BufferAttribute);
}(BufferAttribute); //


export { Float64BufferAttribute, Float32BufferAttribute, Float16BufferAttribute, Uint32BufferAttribute, Int32BufferAttribute, Uint16BufferAttribute, Int16BufferAttribute, Uint8ClampedBufferAttribute, Uint8BufferAttribute, Int8BufferAttribute, BufferAttribute };